var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#147F74",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.986 7h6.03V4.02C9.017 2.025 7.989 1 6 1 4.013 1 2.986 2.024 2.986 4.02V7z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    x: 1,
    y: 7,
    fill: "#147F74",
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocked);
export default __webpack_public_path__ + "static/media/icon-locked.951e7130.svg";
export { ForwardRef as ReactComponent };